import * as XLSX from 'xlsx';
import { format } from './format';
import { GetCurrencySymbol } from '../../../../core/utils/GetCurrenciesData';
import GetBasicDetails from '../../../../core/utils/GetBasicDetails';

export const generate = (series: any, title: string = 'Account Statement.xlsx', isGroup = false, translate: Function, affiliateName?: string, viewName?: string, commissionSummary?: any, statementMonth?: string) => {
  const book = XLSX.utils.book_new();
  const {
    organisation: ORG_NAME
  } = GetBasicDetails();

  if (viewName === 'commissionsView') {

    const tierAmountCurrencySymbol: string = GetCurrencySymbol(commissionSummary?.TierAmountCurrency);
    const totalCommissionCurrencySymbol: string = GetCurrencySymbol(commissionSummary?.TotalCommissionCurrency);
    const commPaidCurrencySymbol: string = GetCurrencySymbol(commissionSummary?.CommPaidCurrency);

    if (isGroup) {
      let types: Array<string> = [];

      Object.keys(series).forEach((key, value) => {
        types.push(key);
      });

      types.forEach((type) => {
        const currentSeries = series[type].series,
          currentTypeLabel = series[type].title;

        const sheet = [
          [translate('xlsx.column.label.partner.account')],
          [''],
          [translate('xlsx.column.label.partner'), `${affiliateName}`],
          [translate('xlsx.column.label.brand.name'), `${ORG_NAME}`],
          [translate('xlsx.column.label.statement.month'), `${statementMonth}`],
          [translate('xlsx.column.label.paid.date'), `${commissionSummary?.CommPaidDate}`, translate('xlsx.column.label.paid.currency'), `${commissionSummary?.CommPaidCurrency}`, translate('xlsx.column.label.rate'), `${commissionSummary?.CommRate}`, translate('xlsx.column.label.total.closed.contracts'), `${commissionSummary?.TotalClosedContracts}`, translate('xlsx.column.label.new.trading.clients'), `${commissionSummary?.NewTradingClients}`],
          [translate('xlsx.column.label.first.tier'), `${tierAmountCurrencySymbol}${commissionSummary?.FirstTierCommissionAmount}`,
          translate('xlsx.column.label.second.tier'), `${tierAmountCurrencySymbol}${commissionSummary?.SecondTierCommissionAmount}`,
          translate('xlsx.column.label.third.tier'), `${tierAmountCurrencySymbol}${commissionSummary?.ThirdTierCommissionAmount}`,
          translate('xlsx.column.label.total.commission'), `${totalCommissionCurrencySymbol}${commissionSummary?.TotalCommissionAmount}`,
          translate('xlsx.column.label.total.amount.paid'), `${commPaidCurrencySymbol}${commissionSummary?.TotalCommissionAmountPaid}`],
          ['', ''],
          [translate('xlsx.column.label.transactions'), ''],
          ['', ''],
          []
        ];

        currentSeries && currentSeries.length > 0 && currentSeries[0].fields.forEach((column: any) => {
          sheet[sheet.length - 1].push(column.fieldLabel);
        });

        currentSeries.forEach((event: any) => {
          const row: Array<any> = [];
          event.fields.forEach((column: any) => {
            row.push(`${column.fieldValuePrefix ? column.fieldValuePrefix : ''}${format(column)}`);
          });

          sheet.push(row);
        });
        currentSeries && currentSeries.length > 0 && XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(sheet), currentTypeLabel);
      })

    } else {
      const sheet = [
        [translate('xlsx.column.label.partner.account')],
        [''],
        [translate('xlsx.column.label.partner'), `${affiliateName}`],
        [translate('xlsx.column.label.brand.name'), `${ORG_NAME}`],
        [translate('xlsx.column.label.statement.month'), `${statementMonth}`],
        [translate('xlsx.column.label.paid.date'), `${commissionSummary?.CommPaidDate}`,
        translate('xlsx.column.label.paid.currency'), `${commissionSummary?.CommPaidCurrency}`,
        translate('xlsx.column.label.rate'), `${commissionSummary?.CommRate}`,
        translate('xlsx.column.label.total.closed.contracts'), `${commissionSummary?.TotalClosedContracts}`,
        translate('xlsx.column.label.new.trading.clients'), `${commissionSummary?.NewTradingClients}`,
        translate('xlsx.column.label.total.commission'), `${totalCommissionCurrencySymbol}${commissionSummary?.TotalCommissionAmount}`,
        translate('xlsx.column.label.total.amount.paid'), `${commPaidCurrencySymbol}${commissionSummary?.TotalCommissionAmountPaid}`],
        ['', ''],
        [translate('xlsx.column.label.commission.payment.breakdown'), ''],
        ['', ''],
        []
      ];

      series[0].fields.forEach((column: any) => {
        sheet[sheet.length - 1].push(column.fieldLabel);
      });

      series.forEach((event: any) => {
        const row: Array<any> = [];
        event.fields.forEach((column: any) => {
          row.push(`${column.fieldValuePrefix ? column.fieldValuePrefix : ''}${format(column)}`);
        });

        sheet.push(row);
      });

      XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(sheet));
    }

  } else if (viewName === 'accountView' && !isGroup) {
    const sheet = [
      [translate('xlsx.column.label.partner.account')],
      [''],
      [translate('xlsx.column.label.partner'), `${affiliateName}`],
      [translate('xlsx.column.label.brand.name'), `${ORG_NAME}`],
      ['', ''],
      [translate('xlsx.column.label.month')]
    ];

    series[0].fields.forEach((column: any) => {
      sheet[sheet.length - 1].push(column.fieldLabel);
    });

    series.forEach((event: any) => {
      const row = [event.event.eventLabel];
      event.fields.forEach((column: any) => {
        row.push(`${column.fieldValuePrefix ? column.fieldValuePrefix : ''}${format(column)}`);
      });

      sheet.push(row);
    });

    XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(sheet));
  } else if (viewName === 'referralsView' && isGroup) {
    let types: Array<string> = [];

    Object.keys(series).forEach((key, value) => {
      types.push(key);
    });

    types.forEach((type) => {
      const currentSeries = series[type].series,
        currentTypeLabel = series[type].title;
      const sheet = [
        [translate('xlsx.column.label.partner.account')],
        [''],
        [translate('xlsx.column.label.partner'), `${affiliateName}`],
        [translate('xlsx.column.label.brand.name'), `${ORG_NAME}`],
        [translate('xlsx.column.label.statement.month'), `${statementMonth}`],
        ['', ''],
        ['', ''],
        []
      ];

      currentSeries && currentSeries.length > 0 && currentSeries[0].fields.forEach((column: any) => {
        sheet[sheet.length - 1].push(column.fieldLabel);
      });

      currentSeries.forEach((event: any) => {
        const row: Array<any> = [];
        event.fields.forEach((column: any) => {
          row.push(`${column.fieldValuePrefix ? column.fieldValuePrefix : ''}${format(column)}`);
        });

        sheet.push(row);
      });
      currentSeries && currentSeries.length > 0 && XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(sheet), currentTypeLabel);
    })
  }
  return XLSX.writeFile(book, title);
};
